import { lazyWithRetry } from './lazy';
import HomeContainerComponent, { RedirectToHome } from '../../features/home/HomeContainer';
import { NotFoundPage } from '../components/not-found/NotFoundPage';

const IntegrationsRoutes = lazyWithRetry(
  () => import('../../features/integrations/IntegrationsRoutes')
);
const ReportRoutes = lazyWithRetry(
  () => import('../../features/reports/ReportRoutes')
);
const AdminRoutes = lazyWithRetry(
  () => import('../../features/admin/AdminRoutes')
);

const routes = [
  {
    path: '/d',
    exact: false,
    component: IntegrationsRoutes,
  },
  {
    path: '/r',
    exact: false,
    component: ReportRoutes,
  },
  {
    path: '/a/notfound',
    exact: true,
    component: NotFoundPage,
  },
  {
    path: '/a',
    exact: false,
    component: AdminRoutes,
  },
  {
    path: '/',
    exact: true,
    component: RedirectToHome,
  },
  {
    path: '/app',
    exact: true,
    component: HomeContainerComponent,
  },
  {
    path: '*',
    exact: false,
    component: NotFoundPage,
  },
];

export default routes;
